import { inject, Injectable } from '@angular/core';

import { DealerConsent } from '../../../../model/customer-information.model';
import { RetailCrmAccountUpdateInput } from '../../model/requests/update-account.model';
import { RetailCrmCustomerFieldsRequestModelMapper } from './customer-fields-model.mapper';

@Injectable({
  providedIn: 'root',
})
export class RetailCrmDealerConsentRequestBodyMapper {
  private readonly customerFieldModelMapper = inject(RetailCrmCustomerFieldsRequestModelMapper);

  /**
   * The consent-only subset of {@link RetailCrmAccountUpdateInput} (CUSTAPP-597).
   */
  mapDealerConsent(dealerConsent: DealerConsent): RetailCrmAccountUpdateInput {
    return { privacyConsent: this.customerFieldModelMapper.mapPrivacyConsent(dealerConsent) };
  }
}
